<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/contracts.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">
        {{ $t('Repositório de Arquivos - Estrutura de Pastas') }}
      </span>

      <v-spacer></v-spacer>
    </div>

    <div class="d-flex justify-space-between flex-wrap">
      <v-row dense class="ma-0" align="center" style>
        <v-col cols="12" sm="5" style="min-width: 222px">
          <label class="label">Nome</label>
          <v-text-field
            v-model="filterListFolderWithDoc.name"
            class="primary-input"
            outlined
            hide-details="auto"
            placeholder="Pesquisar por Nome"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" style="margin-top: auto">
          <v-btn class="primary-button ma-1 mb-4" depressed @click="loadData">
            Filtrar
          </v-btn>
        </v-col>
      </v-row>

      <div style="margin-top: 18px; align-content: center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="primary-button ma-1 mb-4"
              color="secondary"
              v-bind="attrs"
              v-on="on"
              v-if="institution.userType < 3 || institution.userType == 8"
            >
              Novo item
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item-group active-class="info--text text--accent-2">
              <v-list-item
                v-for="(item, index) in addMenuItems"
                :key="index"
                @click="item.action"
                width="100%"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-expand-transition>
      <div class="d-flex justify-end" v-if="downloadList.length > 0">
        <v-btn depressed class="secondary-button" @click="getZip">
          Baixar arquivos ({{ downloadList.length }} selecionados)
        </v-btn>
      </div>
    </v-expand-transition>

    <div class="mt-6 topper-espansion">
      <p class="ma-0 topper-espansion-title">Identificação</p>
      <p class="ma-0 topper-espansion-title">Ações</p>
    </div>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel
        v-for="(item, i) in listFolderWithDoc"
        :key="i"
        :readonly="item.isDocument"
      >
        <v-expansion-panel-header
          :hide-actions="item.isDocument"
          :style="`${item.isDocument ? 'cursor: default' : ''}`"
        >
          <div
            v-if="item.isDocument"
            class="d-flex justify-center"
            style="max-width: 20px; margin-top: -6px"
          >
            <v-checkbox
              class="mr-1"
              dense
              small
              v-model="item.selected"
              hide-details
              @click="addToDownloadList(item)"
            ></v-checkbox>
          </div>
          <span
            v-if="item.isDocument"
            style="margin-bottom: -4px; margin-left: 6px"
          >
            <v-icon class="pr-2" style="margin-top: -3px">
              mdi-file-document-outline
            </v-icon>
            <span class="font-weight-medium pt-2">{{ item.name }}</span>
          </span>
          <span v-else>
            <v-icon class="pr-2" style="margin-top: -3px">
              mdi-folder-outline
            </v-icon>
            <span class="font-weight-medium pt-2">{{ item.name }}</span>
          </span>
          <div
            :style="`display: flex; justify-content: flex-end; ${
              item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
            }`"
          >
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="primary"
                    v-if="institution.userType < 3 || institution.userType == 8"
                    @click.stop="
                      item.isDocument ? editDocument(item) : updateFolder(item)
                    "
                  >
                    <v-icon small color="#f5f5f5">mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-menu v-if="!item.isDocument" offset-y>
                <template v-slot:activator="{ on }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn }">
                      <v-btn
                        class="ma-1"
                        small
                        depressed
                        color="primary"
                        v-if="
                          institution.userType < 3 || institution.userType == 8
                        "
                        v-on="{ ...on, ...tooltipOn }"
                      >
                        <v-icon small color="#f5f5f5">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar</span>
                  </v-tooltip>
                </template>
                <v-list nav dense>
                  <v-list-item-group active-class="info--text text--accent-2">
                    <v-list-item
                      v-for="(actionItem, index) in addTableItems"
                      :key="index"
                      @click.stop="actionItem.action(item)"
                      width="100%"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon>{{ actionItem.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>{{
                        actionItem.title
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>

              <v-tooltip v-if="item.isDocument" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="primary"
                    @click.stop="getFile(item)"
                  >
                    <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                  </v-btn>
                </template>
                <span>Abrir documento</span>
              </v-tooltip>

              <v-tooltip v-if="item.isDocument" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="item.extension === 'pdf'"
                    class="ma-1"
                    :readonly="item.validated"
                    :color="item.validated ? 'secondary' : 'primary'"
                    depressed
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="validateDoc(item)"
                    small
                  >
                    <v-icon dark> mdi-check </v-icon>
                  </v-btn>
                </template>
                <span>{{
                  item.validated ? 'Documento validado' : 'Validar documento'
                }}</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1"
                    small
                    depressed
                    color="#ff4f64"
                    v-if="institution.userType < 3 || institution.userType == 8"
                    @click.stop="
                      item.isDocument
                        ? deleteDocument(item)
                        : deleteFolder(item)
                    "
                  >
                    <v-icon small color="#f5f5f5">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <StandardCommonFolder
            v-if="!item.isDocument"
            :folder="item"
            :add-table-items="addTableItems"
            :index="i"
            :active="panel === i"
            @edit-document="editDocument"
            @update-folder="updateFolder"
            @get-file="getFile"
            @validate-doc="validateDoc"
            @delete-document="deleteDocument"
            @delete-folder="deleteFolder"
            @add-to-download-list="addToDownloadList"
            @open-add-folder-modal="openAddFolderModal"
            @open-add-doc-modal="openAddDocModal"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="modal" max-width="500px">
      <v-form ref="form">
        <Manage
          :edit-mode="editMode"
          :add-to-do-mode="addToDoMode"
          :new-document="newDocument"
          :menu-expire-date="menuExpireDate"
          :valid.sync="valid"
          :folders="folders"
          :all-folders-without-remove="allFoldersWithoutRemove"
          :all-folders="allFolders"
          :key="dialogKey"
          ref="commonForm"
          @close-modal="closeModal"
          @update-document="updateDocument"
          @add-document="addDocument"
        />
      </v-form>
    </v-dialog>

    <v-dialog v-model="folderModal" :key="folderDialogKey" max-width="500px">
      <v-card>
        <v-card-title>
          <h2 style="font-size: 21px">
            {{ editFolderMode ? 'Editar Pasta' : 'Adicionar Pasta' }}
          </h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="folderForm">
            <label class="label">Nome da pasta</label>
            <v-text-field
              placeholder="Nome da pasta"
              class="primary-input"
              outlined
              hide-details="auto"
              v-model="folder.name"
              :rules="[(v) => !!v || 'Nome da pasta é obrigatória']"
              required
            ></v-text-field>
            <label class="label">Pasta</label>
            <v-select
              placeholder="Selecione a pasta"
              class="primary-input"
              outlined
              hide-details="auto"
              v-model="folder.folderId"
              :items="
                editFolderMode
                  ? folder.folderId
                    ? allFoldersWithoutOwn
                    : allFoldersWithoutRemoveAndOwn
                  : allFoldersWithoutRemove
              "
              item-text="name"
              item-value="id"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button ma-1 mb-4"
            depressed
            @click="
              folderModal = false
              folderDialogKey = !folderDialogKey
            "
            >Cancelar</v-btn
          >
          <v-btn
            class="primary-button ma-1 mb-4"
            depressed
            @click="editFolderMode ? confirmUpdateFolder() : addFolder()"
          >
            {{ editFolderMode ? 'Atualizar' : 'Adicionar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addToFolderModal"
      :key="addToFolderDialogKey"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h2 style="font-size: 21px">Adicionar Nova Pasta</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="folderForm">
            <label class="label">Nome da pasta</label>
            <v-text-field
              placeholder="Nome da pasta"
              class="primary-input"
              outlined
              hide-details="auto"
              v-model="folder.name"
              :rules="[(v) => !!v || 'Nome da pasta é obrigatória']"
              required
            ></v-text-field>
            <label class="label">Pasta</label>
            <v-select
              placeholder="Selecione a pasta"
              class="primary-input"
              outlined
              disabled
              hide-details="auto"
              v-model="folder.folderId"
              :items="folder.folderId ? allFolders : allFoldersWithoutRemove"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="primary-button ma-1 mb-4"
            depressed
            @click="
              addToFolderModal = false
              addToFolderDialogKey = Date.now()
            "
            >Cancelar</v-btn
          >
          <v-btn
            class="primary-button ma-1 mb-4"
            depressed
            @click="addFolder()"
          >
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja excluir este documento?
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="ma-1" color="error" text @click="confirmDelete()"
            >Excluir</v-btn
          >
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteFolderDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja excluir esta pasta e todos os documentos
            que estão dentro dela?
          </div>

          <v-btn
            class="ma-1"
            color="grey"
            text
            @click="deleteFolderDialog = false"
            >Cancelar</v-btn
          >
          <v-btn class="ma-1" color="error" text @click="confirmDeleteFolder()"
            >Excluir</v-btn
          >
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import Manage from './components/manage.vue'
import StandardCommonFolder from './components/standardCommonFolder.vue'

export default {
  name: 'StandardFilesRepository',

  components: {
    Manage,
    StandardCommonFolder,
  },

  data() {
    return {
      user: {},
      page: 1,
      totalPages: null,
      totalItensOnPage: 0,
      totalItems: 0,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      downloadList: [],
      menuStartDate: false,
      menuEndDate: false,
      startDate: null,
      endDate: null,
      documents: [],
      apiService: new ApiService(),
      loading: false,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filter: {
        page: 1,
        pageSize: 10,
        name: '',
      },
      modal: false,
      deleteDialog: false,
      valid: false,
      editMode: false,
      selectedDocument: null,
      newDocument: {
        name: '',
        file: null,
        institutionId: null,
        expireDate: null,
        fileBase64: '',
      },
      menuExpireDate: false,
      dialogKey: Date.now(),
      headerCheckbox: false,
      tab: 0,
      folderModal: false,
      folderDialogKey: Date.now() + 1,
      folder: {
        name: '',
        institutionId: '',
        folderId: null,
      },
      folders: [],
      deleteFolderDialog: false,
      selectedFolder: null,
      editFolderMode: false,
      expanded: [],
      secondExpanded: [],
      thirdExpanded: [],
      singleExpand: true,
      moveFolderModal: false,
      moveFolderDialogKey: Date.now() + 2,
      selectedFolderToMove: null,
      combinedItems: [],
      loadingCombinedTable: false,
      combinedPage: 1,
      combinedPageSize: 10,
      allFolders: [],
      availableFoldersToMove: [],
      listFolderWithDoc: [],
      filterListFolderWithDoc: {
        institutionId: null,
        name: '',
        page: 1,
        pageSize: 10,
      },
      specificFolder: null,
      allFoldersWithoutRemove: [],
      panel: null,
      addMenuItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openFolderModal,
        },
      ],
      addTableItems: [
        {
          title: 'Adicionar Documento',
          icon: 'mdi-file-document-plus-outline',
          action: this.openAddDocModal,
        },
        {
          title: 'Adicionar Pasta',
          icon: 'mdi-folder-plus-outline',
          action: this.openAddFolderModal,
        },
      ],
      addToFolderModal: false,
      addToFolderDialogKey: Date.now() + 3,
      addToDoMode: false,
      allFoldersWithoutOwn: [],
      allFoldersWithoutRemoveAndOwn: [],
      institution: {},
    }
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.loadData()
  },

  watch: {
    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getListFolderWithDoc()
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getListFolderWithDoc()
    },
  },

  methods: {
    async loadData() {
      try {
        await Promise.all([this.getAllFolders()])
      } finally {
        this.getListFolderWithDoc()
      }
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    addToDownloadList(file) {
      if (file.selected) {
        this.downloadList.push(file)
      } else {
        this.downloadList = this.downloadList.filter((x) => x.id != file.id)
      }

      this.headerCheckbox = this.documents.every((doc) => doc.selected)
    },

    async getZip() {
      if (this.downloadList.length > 25) {
        this.$toast.warning('Máximo de 25 arquivos por vez')
        return
      }
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${
          this.downloadList.length
        } ${this.$t('selecionados')}`
      )
      const ids = this.downloadList.map((x) => x.id)

      await this.apiService
        .post(`StandardCommonAreaDocument/zip`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `arquivos_em_lote`)
          document.body.appendChild(link)
          link.click()
          this.downloadList = []
        })
    },

    getFile(document) {
      if (document.filePath) {
        if (document.filePath.includes('equipacarefix.blob.core')) {
          const url = document.filePath
          window.open(url)
        } else {
          const url =
            process.env.VUE_APP_BASE_URL +
            document.filePath.replace('wwwroot/', '')
          window.open(url)
        }
      } else {
        this.getDocument(document)
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : 'Sem registros'
    },

    saveCreatedAt(date) {
      this.startDate = this.formatDate(this.filter.createdAt)
      this.$refs.menuStartDate.save(date)
    },

    saveExpireDate(date) {
      this.endDate = this.formatDate(this.filter.expireDate)
      this.$refs.menuEndDate.save(date)
    },

    openModal() {
      this.editMode = false
      this.addToDoMode = false
      this.newDocument = {
        name: '',
        file: null,
        institutionId: null,
        expireDate: null,
      }
      this.modal = true
      this.dialogKey = Date.now()
    },

    openAddDocModal(item) {
      this.editMode = false
      this.addToDoMode = true
      this.newDocument = {
        name: '',
        file: null,
        folderId: item.id,
        institutionId: null,
        expireDate: null,
      }
      this.modal = true
      this.dialogKey = Date.now()
    },

    closeModal() {
      this.modal = false
      this.dialogKey = Date.now()
    },

    async addDocument() {
      if (this.$refs.form.validate()) {
        if (!this.newDocument.file) {
          this.$toast.error('Nenhum arquivo selecionado!')
          return
        }

        this.loading = true
        const reader = new FileReader()
        reader.readAsDataURL(this.newDocument.file)

        reader.onload = () => {
          const extension = this.newDocument.file.name.split('.').pop()
          const base64String = reader.result

          const institutionId = JSON.parse(
            localStorage.getItem('institution')
          ).id

          const documentData = {
            identification: this.newDocument.name,
            folderId: this.newDocument.folderId,
            filePath: base64String,
            extension: extension,
            institutionId: institutionId,
            expireDate: this.newDocument.expireDate,
          }

          this.apiService
            .post('StandardCommonAreaDocument/add', documentData)
            .then(() => {
              this.$toast.success('Documento adicionado com sucesso!')
              this.closeModal()
              this.loadData()
              this.loading = false
            })
            .catch((error) => {
              this.$toast.error('Erro ao adicionar o documento.')
              this.loading = false
            })
        }

        reader.onerror = () => {
          this.$toast.error('Erro ao ler o arquivo.')
          this.loading = false
        }
      }
    },

    async updateDocument() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const documentData = {
          id: this.selectedDocument.id,
          identification: this.newDocument.name,
          folderId: this.newDocument.folderId,
          institutionId: JSON.parse(localStorage.getItem('institution')).id,
          expireDate: this.newDocument.expireDate,
        }

        if (this.newDocument.file) {
          const reader = new FileReader()
          reader.readAsDataURL(this.newDocument.file)

          reader.onload = () => {
            const extension = this.newDocument.file.name.split('.').pop()
            documentData.filePath = reader.result
            documentData.extension = extension

            this.sendUpdateRequest(documentData)
          }

          reader.onerror = () => {
            this.$toast.error('Erro ao ler o arquivo.')
            this.loading = false
          }
        } else {
          documentData.filePath = this.selectedDocument.filePath
          documentData.extension = this.selectedDocument.extension
          this.sendUpdateRequest(documentData)
        }
      }
    },

    sendUpdateRequest(documentData) {
      this.apiService
        .post('StandardCommonAreaDocument/edit', documentData)
        .then(() => {
          this.$toast.success('Documento atualizado com sucesso!')
          this.closeModal()
          this.loadData()
          this.loading = false
        })
        .catch((error) => {
          this.$toast.error('Erro ao atualizar o documento.')
          this.loading = false
        })
    },

    editDocument(item) {
      this.editMode = true
      this.addToDoMode = false
      this.selectedDocument = item
      this.newDocument = {
        ...item,
      }
      this.modal = true
    },

    deleteDocument(item) {
      this.selectedDocument = item
      this.deleteDialog = true
    },

    confirmDelete() {
      const selectedDocumentId = this.selectedDocument.id
      this.apiService
        .delete(`StandardCommonAreaDocument/remove/${selectedDocumentId}`)
        .then(() => {
          this.loadData()
          this.$toast.success('Documento excluído com sucesso!')
          this.deleteDialog = false
        })
        .catch(() => {
          this.$toast.error('Erro ao excluir o documento.')
          this.deleteDialog = false
        })
    },

    validateDoc(document) {
      const userSignature = JSON.parse(
        localStorage.getItem('user')
      ).signatureImage
      if (!document.validated) {
        if (userSignature) {
          this.newDocument.file = document
          const documentId = this.newDocument.file.id
          this.apiService
            .post(`StandardCommonAreaDocument/validate/${documentId}`)
            .then(() => {
              this.loadData()
              this.$toast.success('Documento validado com sucesso')
            })
            .catch((error) => {
              this.$toast.error('Erro ao validar o documento.')
            })
        } else {
          this.$toast.error(
            'Assinatura não encontrada, verifique o cadastro de sua assinatura.'
          )
        }
      } else {
        this.$toast.error('Documento já validado!')
      }
    },

    async getAllFolders(itemId) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      try {
        const response = await this.apiService.get(
          `StandardCommonAreaDocumentFolder/${institutionId}`
        )
        this.allFolders = [...response.content]
        this.allFoldersWithoutRemove = [...response.content]
        if (itemId) {
          this.allFoldersWithoutOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
          this.allFoldersWithoutRemoveAndOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
        }
        this.addOptionRemoveToAllFolders()
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addOptionRemoveToAllFolders() {
      this.allFolders.unshift({
        id: null,
        name: 'Remover das pastas',
      })
      this.allFoldersWithoutOwn.unshift({
        id: null,
        name: 'Remover das pastas',
      })
    },

    async getFolders() {
      try {
        const response = await this.apiService.get(
          'StandardCommonAreaDocumentFolder/list',
          this.filter
        )
        this.folders = response.content.data
      } catch (error) {
        console.log(error)
        console.error('Erro ao carregar pastas.')
      }
    },

    addFolder() {
      if (this.$refs.folderForm.validate()) {
        this.folder.institutionId = JSON.parse(
          localStorage.getItem('institution')
        ).id
        this.apiService
          .post('StandardCommonAreaDocumentFolder/add', this.folder)
          .then(() => {
            this.$toast.success('Pasta criada com sucesso!')
            this.folderModal = false
            this.addToFolderModal = false
            this.loadData()
          })
      }
    },

    openFolderModal() {
      this.editFolderMode = false
      this.folderModal = true
      this.folderDialogKey = Date.now()
      this.folder = {
        name: '',
        institutionId: JSON.parse(localStorage.getItem('institution')).id,
      }
    },

    openAddFolderModal(item) {
      this.addToFolderModal = true
      this.addToFolderDialogKey = Date.now()
      this.folder = {
        name: '',
        institutionId: JSON.parse(localStorage.getItem('institution')).id,
        folderId: item.id,
      }
    },

    updateFolder(item) {
      this.editFolderMode = true
      this.folderModal = true
      this.folderDialogKey = Date.now()
      this.folder = { ...item }
      this.getAllFolders(item.id)
    },

    confirmUpdateFolder() {
      if (this.$refs.folderForm.validate()) {
        this.apiService
          .put(`StandardCommonAreaDocumentFolder/`, this.folder)
          .then(() => {
            this.$toast.success('Pasta editada com sucesso!')
            this.folderModal = false
            this.loadData()
          })
      }
    },

    deleteFolder(item) {
      this.selectedFolder = item
      this.deleteFolderDialog = true
    },

    confirmDeleteFolder() {
      const selectedFolderId = this.selectedFolder.id
      this.apiService
        .delete(`StandardCommonAreaDocumentFolder/${selectedFolderId}`)
        .then(() => {
          this.deleteFolderDialog = false
          this.$toast.success('Pasta excluída com sucesso!')
          this.loadData()
        })
    },

    async getListFolderWithDoc() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.filterListFolderWithDoc.institutionId = institutionId
      this.filterListFolderWithDoc.page = this.page
      this.filterListFolderWithDoc.pageSize = this.pageSize

      try {
        const response = await this.apiService.get(
          `StandardCommonAreaDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.panel = null
        this.listFolderWithDoc = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
        this.totalItensOnPage = response.content.data.length
      } catch (error) {
        console.error('Erro ao carregar a lista de documentos.', error)
      }
    },
  },
}
</script>

<style scoped>
.topper-espansion {
  background-color: #4c6d97;
  display: flex;
  min-height: 48px;
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  padding: 0 60px 0 28px;
}
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
